import { useFetcher } from "@remix-run/react";
import { useEffect } from "react";
import { MoodboardCard } from ".";
import { Moodboard } from "./MoodboardCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

export default function MoodboardsCTA() {
  const fetcher = useFetcher<{ moodboards: Moodboard[] }>();

  useEffect(() => {
    if (!fetcher.data?.moodboards && fetcher.state === "idle") {
      fetcher.load("/account/moodboards");
    }
  }, [fetcher]);

  return (
    <Swiper
      modules={[Navigation]}
      slidesPerView="auto"
      spaceBetween={40}
      centeredSlides
      wrapperClass="w-max mx-auto py-10"
      navigation
      breakpoints={{
        768: {
          slidesPerView: 3,
          spaceBetween: 40,
          centeredSlides: false,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 40,
          centeredSlides: false,
        },
      }}
    >
      {fetcher.data?.moodboards.map((m) => (
        <SwiperSlide key={m.id} className="max-w-72">
          <MoodboardCard {...m} className="" />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
